/* global Event */

import 'babel-polyfill'
import 'custom-event-polyfill'
import 'whatwg-fetch'
import './containers/utilities/console-shim'
import './containers/utilities/url-polyfill.js'
import Raven from 'raven-js'
import {RELEASE, SENTRY_URL} from './constants/config'
import {isOldBrowser} from './utils'

require('expose-loader?React!react')
// use patched version for quiet failure
// require('expose-loader?ReactDOM!./patched-react-dom')
require('expose-loader?ReactDOM!react-dom')
require('expose-loader?MJO!./blocks') // semicolon is important

// Polyfill for requestAnimationFrame
;

(function() {
  let lastTime = 0
  const vendors = ['ms', 'moz', 'webkit', 'o']
  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    window.cancelAnimationFrame =
      window[vendors[x] + 'CancelAnimationFrame'] ||
      window[vendors[x] + 'CancelRequestAnimationFrame']
  }
  
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback, element) {
      const currTime = new Date().getTime()
      const timeToCall = Math.max(0, 16 - (currTime - lastTime))
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }
  }
  
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id)
    }
  }
}())

if (!isOldBrowser()) {
  Raven.config(SENTRY_URL, {
    release: RELEASE,
  }).install()
}



// WEBPACK FOOTER //
// ./src/client.jsx